import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../shared/BrandLogo';
import '../../styles/landing/BrandLogo.css';
import '../../styles/landing/LandingFooter.css';

const LandingFooter: React.FC = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="landing-footer">
            <div className="landing-container landing-footer__inner">
                <div className="landing-footer__brand">
                    <BrandLogo
                        size={40}
                        wordmarkClassName="landing-footer__logo"
                    />
                    <p className="landing-footer__tagline">{t('footer.tagline')}</p>
                </div>
                <p className="landing-footer__legal">
                    &copy; {currentYear} MarryGo. {t('footer.rights')}{' '}
                    <button type="button" className="landing-footer__link">
                        {t('footer.privacy')}
                    </button>
                    {' · '}
                    <button type="button" className="landing-footer__link">
                        {t('footer.terms')}
                    </button>
                </p>
            </div>
        </footer>
    );
};

export default LandingFooter;
